import React from 'react'
import { Link } from 'react-router-dom'
import "./footer.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram, faFacebook, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { BUSINESS, LEGAL_ROUTES } from '../../config/business'

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="footer-grid">

        <div className="footer-col">
          <h4>{BUSINESS.brand}</h4>
          <p className="footer-tagline">
            Patna's electric bicycle specialist. Authorised dealer for EMotorad
            and Motovolt. Sales, spares and service.
          </p>
          <p className="footer-label">Showroom</p>
          <p>{BUSINESS.operatingAddress}</p>
        </div>

        <div className="footer-col">
          <h4>Registered Address</h4>
          <p>{BUSINESS.registeredAddress}</p>
          <p className="footer-label">Legal entity</p>
          <p>
            {BUSINESS.legalName}
            {BUSINESS.gstin && <><br />GSTIN: {BUSINESS.gstin}</>}
            {BUSINESS.cin && <><br />CIN: {BUSINESS.cin}</>}
          </p>
        </div>

        <div className="footer-col">
          <h4>Policies</h4>
          <ul className="footer-links">
            {LEGAL_ROUTES.map((r) => (
              <li key={r.path}>
                <Link to={r.path}>{r.label}</Link>
              </li>
            ))}
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/about">About Us</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Get in touch</h4>
          <ul className="footer-links">
            <li>
              <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
            </li>
            <li>
              <a href={`tel:+${BUSINESS.phoneRaw}`}>{BUSINESS.phone}</a>
            </li>
            <li>
              <a
                href={`https://wa.me/${BUSINESS.whatsapp}`}
                target="_blank"
                rel="noreferrer"
              >
                Chat on WhatsApp
              </a>
            </li>
          </ul>
          <p className="footer-hours">{BUSINESS.supportHours}</p>

          <div className="footer-social">
            <a aria-label="Twitter" href="https://twitter.com/pdpro1/status/1568647764745277441" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>
            <a aria-label="Instagram" href="https://www.instagram.com/rango_ecycles/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} size='lg' /></a>
            <a aria-label="Facebook" href="https://www.facebook.com/rangoecyclespatna" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} size='lg' /></a>
            <a aria-label="YouTube" href="https://www.youtube.com/@rango_ecycles" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} size='lg' /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © {year} {BUSINESS.legalName}. All rights reserved.
        </p>
        <p className="footer-currency">
          All prices and transactions on this website are in{' '}
          <strong>{BUSINESS.currencyLabel}</strong>. We sell and deliver within{' '}
          {BUSINESS.serviceArea} only — we do not ship internationally or export.
        </p>
      </div>
    </footer>
  )
}
